import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import Badge from '@material-ui/core/Badge';
import Divider from '@material-ui/core/Divider';
import FlagIcon from '@material-ui/icons/Flag';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import React, { useEffect } from 'react';
import Typography from '@material-ui/core/Typography';
import moment from 'moment';

import SimpleMenu from './SimpleMenu/SimpleMenu';

interface IMessageProps {
    data: {
        [key: string]: any;
    };
    toggleBlock: Function;
    blockedStatusField: string; //@param name of field on data object used to determine whether data is blocked by admin
    text: string; //@param name of field on data that is primary text
    name: string; //@param name of field on data that is the sender's name
    timestamp: string; //@param name of field on data to be used as timestamp
    flagged: string; //@param name of field on data to be used as flagged indicator
    avatar?: string;
    options: any[];
    fetchUserAvatar: any;
    userId: string; //@param name of field on data used as userId
}
const useStyles = makeStyles(theme => ({
    blocked: {
        background: 'red',
    },
    //flag    should be red for flagged messages
    flag: (vars: any) => ({
        color: vars.blocked === undefined || vars.blocked === true ? 'red' : 'green',
    }),
    inline: {
        display: 'inline',
    },
    margin: {},
    message: (vars: any) => ({
        alignItems: 'center',
        backgroundColor: vars.blocked === true ? 'rgba(207, 0, 15,.1)' : theme.palette.background.paper,
        display: 'flex',
        paddingBottom: '5',
        paddingTop: '5',
        width: '100%',
    }),
}));

function Message({
    avatar,
    blockedStatusField,
    data,
    fetchUserAvatar,
    flagged,
    name,
    options,
    text,
    timestamp,
    toggleBlock,
    userId,
}: IMessageProps) {
    const classes = useStyles({ blocked: data[blockedStatusField], flagged: data[flagged] });
    let derivedUserId = data[userId];
    useEffect(() => {
        fetchUserAvatar(derivedUserId);
    }, [fetchUserAvatar, derivedUserId]);

    //TODO cleanup the different blocks below
    return (
        <React.Fragment>
            <ListItem alignItems="flex-start" className={classes.message} data-cy="Message">
                <ListItemAvatar>
                    <Avatar alt="Remy Sharp" color="primary">
                        {data.avatar ? (
                            <img alt="user avatar" src={data.avatar} width="40" />
                        ) : (
                            `${data[name].charAt(0)}`
                        )}
                    </Avatar>
                </ListItemAvatar>
                <ListItemText
                    primary={`${data[name]} : ${data[text]}`}
                    secondary={
                        <React.Fragment>
                            {' '}
                            <Typography
                                className={classes.inline}
                                color="textPrimary"
                                component="span"
                                variant="body2"
                            ></Typography>
                            {moment.unix(data[timestamp]).fromNow()}{' '}
                        </React.Fragment>
                    }
                />

                {!data[flagged] && (
                    // Allowsuser to block/unblock messages that haven't been flagged
                    <SimpleMenu
                        mode="dark"
                        options={[
                            {
                                label: data[blockedStatusField] ? 'Unblock' : 'Block',
                                callback: function() {
                                    toggleBlock({ id: data.id, status: !data[blockedStatusField] });
                                },
                            },
                        ]}
                    />
                )}
                {data[flagged] && data[blockedStatusField] === undefined && (
                    // Allows user to make initial block/reviewed selection
                    <SimpleMenu
                        mode="dark"
                        options={[
                            {
                                callback: function() {
                                    toggleBlock({ id: data.id, status: true });
                                },
                                label: 'Block',
                            },
                            {
                                callback: function() {
                                    toggleBlock({ id: data.id, status: false });
                                },
                                label: 'Reviewed',
                            },
                        ]}
                    >
                        <Badge
                            badgeContent={Object.keys(data[flagged]).length}
                            className={`${[classes.margin, classes.flag]}`}
                        >
                            <FlagIcon />
                        </Badge>
                    </SimpleMenu>
                )}

                {data[flagged] && (data[blockedStatusField] === true || data[blockedStatusField] === false) && (
                    // Allows user to make initial block/reviewed selection
                    <SimpleMenu
                        mode="dark"
                        options={[
                            {
                                callback: function() {
                                    toggleBlock({ id: data.id, status: !data[blockedStatusField] });
                                },
                                label: data[blockedStatusField] ? 'Unblock' : 'Block',
                            },
                        ]}
                    >
                        <Badge
                            badgeContent={Object.keys(data[flagged]).length}
                            className={`${[classes.margin, classes.flag]}`}
                        >
                            <FlagIcon />
                        </Badge>
                    </SimpleMenu>
                )}
            </ListItem>
            <Divider component="li" variant="inset" />
        </React.Fragment>
    );
}

export default Message;
